import React, { useEffect, useState } from 'react';
import UserStorage from './utility/UserStorage';
import CssBaseline from '@material-ui/core/CssBaseline';
import Main from './Main'

import { MuiThemeProvider } from '@material-ui/core/styles';
import './styles/app.css';

import HeaderAppBar from './components/HeaderAppBar';
import themeService from './themes/themeService';

const styles = {
    root: {
        fontFamily: "'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', 'sans-serif'",
    }
};

const App =  () => {
    const [ isAuthenticated, setIsAuthenticated ] = useState(UserStorage.isAuthenticated());

    useEffect( () => {
        if(!isAuthenticated) {
            UserStorage.clearToken();
            UserStorage.clearLoggedInUser();
        }        
    },[isAuthenticated]); 


    document.title = themeService.getTitle();
    return (
        <MuiThemeProvider theme={themeService.getTheme()}>
            <CssBaseline />
            <div style={styles.root}>
                <HeaderAppBar isAuthenticated={isAuthenticated} setIsAuthenticated={setIsAuthenticated}/>
                <Main setIsAuthenticated={setIsAuthenticated}/>
            </div>
        </MuiThemeProvider>
    );
}

export default App;

